'use client';

import { Fulfillment } from '@instamenu/data-access';
import { Box, CheckoutCard, Label } from '@instamenu/ui-system-next';
import { DeliveryPickupToggle } from '../delivery-pickup-toggle/delivery-pickup-toggle';
import { PickupDetails } from './pickup-details';
import { AddressSelect } from '../address-select/address-select';
import type { Checkout, Order } from '@instamenu/context-checkout';
import { palette, themeVars } from '@instamenu/ui-vanilla-extract';
import { roundUpTo } from '@instamenu/formatters';
import { observer } from 'mobx-react-lite';

export const DeliverySection = observer(function DeliverySection({
  order,
  checkout,
  hasWarning,
}: {
  order: Order;
  checkout: Checkout;
  hasWarning: boolean;
}) {
  const deliveryEstimateMinutes = checkout.deliveryEstimateMinutes;
  const showDeliveryEstimate =
    checkout.isAcceptingInstantOrders &&
    !order.scheduledAt &&
    !!order.deliveryAddress &&
    !checkout.deliveryQuoteFetching &&
    typeof deliveryEstimateMinutes === 'number';

  return (
    <CheckoutCard variant={hasWarning ? 'warning' : 'default'}>
      <Box css={{ marginBottom: themeVars.pad[16] }}>
        <DeliveryPickupToggle />
      </Box>
      {checkout.mode !== Fulfillment.Delivery ? (
        <PickupDetails order={order} />
      ) : (
        <Box>
          <Box
            css={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'baseline',
              gap: 8,
            }}
          >
            <Label>Delivery address</Label>
            {showDeliveryEstimate && (
              <Box
                as="span"
                data-id="delivery-estimate"
                css={{ fontSize: '0.875rem', color: palette.gray600 }}
              >
                Arrives in {roundUpTo(deliveryEstimateMinutes, 5)} minutes
              </Box>
            )}
          </Box>
          <AddressSelect hasButtonInfo buttonProps={{ style: { width: '100%' } }} />
        </Box>
      )}
    </CheckoutCard>
  );
});
